import { BlockType } from '../../blocks/BlockInterface';

import { convertTo62 } from 'uuid-encoding';
import { PropertyType } from '../Property';

export class BlockRegistry {
  private registry: Map<string, BlockType>;

  constructor(blocks: BlockType[]) {
    this.registry = new Map(
      blocks.map(block => [
        convertTo62((block as any)._id),
        block as unknown as BlockType,
      ])
    );
  }

  getBlockType(blockTypeId: string): BlockType {
    const blockType = this.registry.get(blockTypeId);

    if (blockType === undefined) {
      throw new Error(`Block ${blockTypeId} does not exist`);
    }

    return blockType;
  }

  getBlockTypePropertyTypeCopy(
    blockTypeId: string,
    propertyTypeName: string
  ): PropertyType {
    const blockType = this.getBlockType(blockTypeId);

    if (!blockType.properties[propertyTypeName]) {
      throw new Error(
        `Property ${propertyTypeName} on Block ${blockType.name} does not exist`
      );
    }

    return { ...blockType.properties[propertyTypeName] };
  }
}
